export default class DialogUtils {
  /*
   * Dialog widths are px caps, not viewport percentages.
   *
   * A percentage keeps a dialog the same *physical* size on screen while the
   * text inside it grows with browser zoom, so the fields get crushed exactly
   * when the user has asked for bigger text. A px cap keeps the dialog's
   * capacity in characters constant instead, growing physically as the user
   * zooms. The vw term is the small-screen fallback so the cap never exceeds
   * the viewport.
   *
   * The caps are roughly what the old percentages produced on a 1920px screen,
   * so nothing changes noticeably at 100% zoom on a full-size display.
   */
  static SMALL = 'min(600px, 96vw)';
  static MEDIUM = 'min(1100px, 96vw)';
  static M_LARGE = 'min(1400px, 96vw)';
  static LARGE = 'min(1600px, 96vw)';
  static X_LARGE = 'min(1800px, 96vw)';
}
